<template>
    <div>
        <b-modal :visible="modals.billingAddress" size="lg" :title=" $t('general.billingAddress') "
            content-class="card form-rounded-inputs card-ecart" header-class="card-header" ok-disabled
            cancel-variant="none" centered @hidden="fnResetBillingAddress()">
            <AddressForm ref="billingAddress" :addressInformation="addresses.billingAddress"
                :disabledList="disabledFields" />
            <template v-slot:modal-footer>
                <div class="d-flex w-100">
                    <button @click=" fnResetBillingAddress()" class="btn ml-auto"
                        v-text=" $t('general.button.close') "></button>
                    <button @click=" fnValdiateBillingAddress()" class="btn btn-success"
                        :disabled="loading.billingAddress">
                        <i class="fa fa-spinner fa-spin " v-if="loading.billingAddress"></i>
                        <span v-else v-text=" $t('general.save') "></span>
                    </button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import AddressForm from '@/components/AddressForm';
    import {
        mapActions,
        mapMutations,
        mapState
    } from 'vuex';
    export default {
        components: {
            AddressForm,
        },
        data() {
            return {
                disabledFields: ['addressName'],
            }
        },
        computed: {
            ...mapState('EcartNewCart', ['newCart', 'storeList', 'loading', 'modals', 'addresses']),
        },
        methods: {
            ...mapMutations('EcartNewCart', ['changeModal']),
            ...mapActions('EcartNewCart', ['fnApiUpdateAddress']),
            fnResetBillingAddress() {
                this.changeModal({
                    billingAddress: false
                })
            },
            async fnValdiateBillingAddress() {
                let billingAddress = null;
                billingAddress = await this.$refs.billingAddress.fnValidateData();
                if (billingAddress == null) {
                    return false;
                }
                delete billingAddress.id;
                delete billingAddress.address_name;
                if (billingAddress.state.code) {
                    delete billingAddress.state.name;
                }
                this.fnApiUpdateAddress([billingAddress, 'billingAddress']);
            }
        }
    }
</script>